// src/components/Services.js
import React from 'react';
import { Container, Typography } from '@mui/material';

const Services = () => {
  return (
    <Container>
      <Typography variant="h4" sx={{ mt: 4 }}>Our Courses</Typography>
      <Typography sx={{ mt: 2 }}>
        At Prarthana PU Science College, we offer specialized courses like NEET,CET,J2EE etc.
      </Typography>
    </Container>
  );
};

export default Services;
